import * as GameTypes from 'types/game.types';
import { ref } from 'vue';
import { functions, getFirebaseUser } from 'src/firebase';
import { httpsCallable} from "firebase/functions";
import { defineStore } from 'pinia';
import { getDefaultStats } from 'util/game-util';
import { fromLocalStorage, toLocalStorage, clone } from 'util/util';
import { useGlobalStore } from './global';
import { v4 as uuidv4 } from 'uuid';

interface StatsPersistedState {
    latestStats: GameTypes.LocalStats,
    latestRank: number
}

interface StatsRequest {
    gameId: 0,
    data: {
        type: 'best'
    }
}

interface BestStatsRequest {
    gameId: 0
}

interface RankStatsRequest {
    gameId: 0,
    data: GameTypes.LocalStats
}

const GameId = 0;

let devUuid = uuidv4();
const useStatsStore = defineStore('stats-store', () => {
    const global = useGlobalStore();
    let persisted : StatsPersistedState = fromLocalStorage('stats-store', {
        latestStats: getDefaultStats(),
        latestRank: -1
    })

    const latestStats = ref<GameTypes.LocalStats>(persisted.latestStats);
    const latestRank = ref<number>(persisted.latestRank);

    const persist = () => {
        toLocalStorage<StatsPersistedState>('stats-store', {
            latestStats: latestStats.value,
            latestRank: latestRank.value
        })
    }

    /**
     * Stores a new latest stats item with all ranks set to `-1`.
     */
    const setLatest = (stats: GameTypes.LocalStats) => {
        latestStats.value = stats;
        persist();
    }

    /**
     * Returns the most recent stats from localStorage with no rank information.
     */
    const getLatest = () : GameTypes.LocalStats => {
        return clone(latestStats.value);
    }

    /**
     * Retrieves the player's best stats from the server OR throws an error.
     */
    const getBest = async () : Promise<GameTypes.RankedPersistedStats> => {
        console.log('get best stats');

        await getFirebaseUser(); //Ensure we are logged in anon or otherwise
        const getStats = httpsCallable<BestStatsRequest, GameTypes.RankedPersistedStats>(functions, 'getBest');
        return (await getStats({
            gameId: GameId
        })).data;
    }

    /**
     * Returns the given stats object w/ the current and best ranking populated. 
     * If these stats are highest scoring for this deviceId, the server will store as best.
     */
    const rankStats = async (stats: GameTypes.LocalStats) : Promise<GameTypes.RankedPersistedStats> => {
        //throw "Not implemented";
        await getFirebaseUser(); //Ensure we are logged in anon or otherwise
        const rankStats = httpsCallable<RankStatsRequest, GameTypes.RankedPersistedStats>(functions, 'rankStats');
        const data = (await rankStats({
            gameId: GameId,
            data: stats
        })).data;
        /**
         * Calculate rank change before recording latest current rank
         */
        let rankChange = latestRank.value === -1 ? 0 : latestRank.value - data.overrallRank;
        /**
         * Whenever stats are ranked, take note of the current rank so that we can compare next time and return
         * rank difference
         */
        latestRank.value = data.overrallRank;
        persist();

        return data;
        // return {
        //     stats: data,
        //     rankChange
        // }
    }

    return {
        getLatest,
        setLatest,
        getBest,
        rankStats
    }
})

//post-game
 //get latest
 //rank stats
 //if failed,
   //show latest,
 //otherwise
   //show latest w/ rank

export { useStatsStore };